import { ApiPostMedia } from "../interfaces/post.interface";

type Props = {
  mediaFiles: ApiPostMedia[];
  onOpen: (url: string) => void;
};

const PostMedia: React.FC<Props> = ({ mediaFiles, onOpen }) => {
  if (!mediaFiles?.length) return null;

  const total = mediaFiles.length;
  const visibleFiles = mediaFiles.slice(0, 3);
  const remaining = total - 3;

  // One media
  if (total === 1) {
    const media = mediaFiles[0];

    if (media.type === "video") {
      return (
        <div className="mb-3 overflow-hidden rounded-lg">
          <video
            src={media.url}
            controls
            className="w-full max-h-[600px] object-cover"
          />
        </div>
      );
    }

    return (
      <div className="mb-3 overflow-hidden rounded-lg">
        <button
          type="button"
          onClick={() => onOpen(media.url)}
          className="block w-full"
        >
          <img
            src={media.url}
            alt=""
            className="block w-full max-h-[600px] object-cover"
          />
        </button>
      </div>
    );
  }

  // Multiple media
  return (
    <div
      className={`mb-3 grid gap-2 ${
        total === 2 ? "grid-cols-2" : "grid-cols-3"
      }`}
    >
      {visibleFiles.map((media, index) => {
        const isLast = index === visibleFiles.length - 1;
        const hasMore = remaining > 0 && isLast;

        return (
          <button
            key={media.id}
            type="button"
            onClick={() => onOpen(media.url)}
            className="relative aspect-square overflow-hidden rounded-lg"
          >
            {media.type === "video" ? (
              <video
                src={media.url}
                className="h-full w-full object-cover"
              />
            ) : (
              <img
                src={media.url}
                alt=""
                className="h-full w-full object-cover"
              />
            )}

            {hasMore && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/50">
                <span className="text-2xl font-semibold text-white">
                  +{remaining}
                </span>
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default PostMedia;